import React, {useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

import { Line } from 'react-chartjs-2';
import { ChartFilter } from "../../Components/ChartFilter";
import moment from "moment";
import { colorCode, handleValidateCodevalue, myTeampermission, permissionList, DEFAULT_CHART_DATE_RANGE_DAYS } from "../../Utility/constant";
import { handleRequestGetOrder } from "../../Store/dashboard/action";
import qs from 'qs';
import LoaderIcon from '../../Assets/images/loader.svg';
import { requestGetMyTeam } from "../../Store/User/action";
import { resolveOwnerIds, buildChartQueryParams } from "../../Utility/ownerUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const handleGenerateLable = (item) => {
        const label = [];
        for (let i = item; i >= 0; i--) {
            label.push(moment().subtract(i, 'days').format("YYYY-MM-DD"));
        }
        return label;
    }
    
    const data = {
      labels:  handleGenerateLable(6),
      datasets: [
        {
          label: 'Total Order',
          data: [],
          backgroundColor: colorCode[0],
          borderColor: colorCode[0]
        },

        {
          label: 'Via lead',
          data: [],
          backgroundColor: colorCode[1],
          borderColor: colorCode[1]
        },

        {
          label: 'Direct',
          data: [],
          backgroundColor: colorCode[3],
          borderColor: colorCode[3]
        }
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio : false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: false,
          text: '',
        },
      },
    };

const BiztantuLineChart = ({internationalise, isParentLoading}) => {

    const [chartDataset, setChartDataset] = useState(data);
    const [value, setValue] = useState(DEFAULT_CHART_DATE_RANGE_DAYS);
    const[isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();    
    const salesOrderData = useSelector(state => state?.chart?.order);
    const currentUser = useSelector(state => state?.owner?.currentuser);

    const myTeam = useSelector(state => state?.owner?.Team);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    
    const isFirstRender = useRef(true);
    
    const onChange = (e, isType) => {
        const {value} = e.target;
        setValue(value);
    }

    useEffect(() => {
      const fetchChart = async() => {
        setisLoading(true);
        const allOwnerIds = (ownerlist || []).map(item => item.id);

        const isTeamRequired = currentUser?.authorities?.some(item => myTeampermission?.includes(item?.authority));
        let latestTeam = [];
        if(isTeamRequired && myTeam?.length == 0) {
          latestTeam =  await dispatch(requestGetMyTeam(currentUser?.userId), false);
        }

        const reportingTeamIds = (myTeam?.length > 0 ? myTeam : latestTeam).map(item => item.id);
        const isEntireOrg = currentUser?.authorities?.some(item => item?.authority == permissionList?.ALL_ORDER_MANAGE);
         
      
        const queryparam = buildChartQueryParams(
            resolveOwnerIds({
                isEntireOrg,
                allOwnerIds,
                reportingTeamIds,
                currentUserId: currentUser?.userId
            }),
            value
        );
        await dispatch(handleRequestGetOrder({params: queryparam ,paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
                }), true);

                  setisLoading(false);
      
      }

      if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
      }

      if (currentUser) {
          fetchChart();
      }
      
    },[value, currentUser])
    
    const processChartData = (orders, labels) => {
        return (labels || []).map(date => {
            const dayOrders = (orders || []).filter(o =>
            moment(o?.updatedAt).format("YYYY-MM-DD") === date
            );

            const total = dayOrders.length;
            const withLead = dayOrders.filter(o => o.leadId !== null).length;
            const withoutLead = dayOrders.filter(o => o.leadId === null).length;

            return { date, total, withLead, withoutLead };
        });
    };

    const getChartData = (chartData) => ({
        labels: (chartData || []).map(d => d.date),
        datasets: [
            {
            label: handleValidateCodevalue(internationalise,"TOTAL_SALES_ORDER"),
            data: (chartData|| []).map(d => d.total),
            borderColor: colorCode[0],
            backgroundColor: colorCode[0],
            fill: false,
            tension: 0.3,
            },
            {
            label: handleValidateCodevalue(internationalise,"SALES_ORDER_VIA_LEAD"),
            data: (chartData|| []).map(d => d.withLead),
            borderColor: colorCode[1],
            backgroundColor: colorCode[1],
            fill: false,
            tension: 0.3,
            },
            {
            label: handleValidateCodevalue(internationalise,"DIRECT_SALES_ORDER"),
            data: (chartData|| []).map(d => d.withoutLead),
            borderColor: colorCode[2],
            backgroundColor: colorCode[2],
            fill: false,
            tension: 0.3,
            },
        ],
    });

    useEffect(() => {
        const labels = handleGenerateLable(value);
        const processed = processChartData(salesOrderData, labels);
        setChartDataset(getChartData(processed));
    },[value, salesOrderData])
    
    const showChartLoader = isLoading || isParentLoading;
    
    if(showChartLoader) {
       return ( 
       <div className='piechartContainer' style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
          <img
              src={LoaderIcon}
              alt="loading"
              style={{ width: 60, height: 60, animation: "spin 1.2s linear infinite" }}
            />
        </div>);
      } else {

    return (
        <div className='piechartContainer' style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <ChartFilter 
                label={handleValidateCodevalue(internationalise,"SALES_ORDER_SIDEBAR_MENU")}
                onChange={onChange}
                value={value}
                isType="Line"
            />
            <div style={{ position: "relative", flex: 1, minHeight: 0, width: "100%" }}>
                <Line options={options} data={chartDataset} />
            </div>
        </div>
    )
  }
}

export default BiztantuLineChart;